import { Tabs } from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { CompareTabsStyle, CompareTabStyle, TabIconStyle } from "./StyledComponents";

export const TabsComponent = ({ selectedTab, tabs, setSelected, children }) => {
    return (
        <Tabs
            onSelect={(index) => setSelected(tabs[index])}
            selectedIndex={tabs.findIndex((tab) => tab.name === selectedTab.name)}
        >
            <CompareTabsStyle>
                {tabs.map((tab) => (
                    <CompareTabStyle key={tab.id}>
                        {tab.iconName && (
                            <TabIconStyle
                                size="xs"
                                iconName={tab.iconName}
                            />
                        )}
                        <I18n>{tab.title}</I18n>
                    </CompareTabStyle>
                ))}
            </CompareTabsStyle>
            {children}
        </Tabs>
    );
};
